import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import Header from './Header';
import HeaderLinks from './HeaderLinks';
import Footer from './Footer';
import PostsWidget from './PostsWidget';
import LinksWidget from './LinksWidget';
import { BtnAnimationSheen } from '../../helpers/UIElements';
import { FavoritesStatus } from '../Favorites';
import { colors } from '../../styles';
import TestimonialBanner from '../TestimonialBanner';

const styles = css`

  /* Favorites Styles */
  .Favorites_signIn {
    z-index: 200;
      background-color: ${colors.color1};
      position: fixed;
      bottom: 67px;
      right: 0;
      width: 95px;
      @media(min-width: 620px) {
        min-width: 180px;
        width: auto;
      }
      @media(min-width:992px) {
        bottom: 0;
      }
    }
  }
  .FavoritesStatus {
    border: none !important;
  }
`;

class PageWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headerAlt: true,
      headerLinks: false,
    };
    this.lastScroll = 0;
    this.toggleHeaderLinks = this.toggleHeaderLinks.bind(this);
  }

  componentDidMount() {
    // document.addEventListener('scroll', this.handleScroll);
    this.scrollWatcher = setInterval(() => {
      if (this.lastScroll !== window.pageYOffset) {
        this.handleScroll();
      }
    }, 100);
  }

  componentWillUnmount() {
    clearInterval(this.scrollWatcher);
  }

  onScroll = headerAlt => {
    this.setState({ headerAlt });
  }

  handleScroll = () => {
    this.lastScroll = window.pageYOffset;
    const headerAlt = this.lastScroll < 25;
    if (headerAlt !== this.state.headerAlt && !this.state.headerLinks) {
      this.onScroll(headerAlt);
    }
    this.lastRun = Date.now();
  }
  toggleHeaderLinks = () => {
    this.setState(prevState => ({
      headerLinks: !prevState.headerLinks,
    }));
  }

  openFormToggler = () => {
    this.setState({ openForm: !this.state.openForm });
  }

  render() {
    const { headerAlt, headerLinks } = this.state;
    const { children, className, singlePage, testimonial } = this.props;
    return (
      <div className={className}>
        <Header
          headerAlt={headerAlt}
          toggleHeaderLinks={this.toggleHeaderLinks}
          headerLinks={headerLinks}
        />
        {
          !headerLinks &&
          <div>
            { children }
            {
              (!singlePage || !testimonial) &&
              <TestimonialBanner />
            }
            {
              !singlePage &&
              <LinksWidget />
            }
            {
              !singlePage &&
              <PostsWidget />
            }
            <div className={styles}>
              <BtnAnimationSheen className="Favorites_signIn">
                <FavoritesStatus />
              </BtnAnimationSheen>
            </div>
            <Footer openFormToggler={this.openFormToggler} />
          </div>
        }
        {
          headerLinks &&
          <HeaderLinks />
        }
      </div>
    );
  }
}

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  singlePage: PropTypes.bool,
  testimonial: PropTypes.bool,
};

PageWrapper.defaultProps = {
  className: undefined,
  singlePage: false,
  testimonial: false,
};

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/PageWrapper/index.js